import {
  ExclamationCircleIcon,
  ArrowLeftIcon,
} from "@heroicons/react/24/outline";
// import Link from 'next/link';
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "ui/button";
import { StateCustomer, updateCustomer, deleteCustomer } from "lib/actions";
import { useContext, useRef } from "react";
import { AuthContext } from "context/AuthContext";
import { useState } from "react";
import { useSWRConfig } from "swr";
import { ConfirmModalStyles, ITEMS_PER_PAGE } from "lib/constants";
import { showToast } from "ui/components/common";
import Modal from "react-modal";
import { PhoneInput } from "ui/components/common";
import { validatePhoneNumber } from "lib/utils";

export default function Form({ objCustomer }: { objCustomer: any }) {
  const { user } = useContext(AuthContext);
  interface formDataType {
    [key: string]: FormDataEntryValue;
  }
  const responseBody: formDataType = {};
  const navigate = useNavigate();
  const phoneInputRef = useRef(null);

  const [responseData, setResponseData] = useState<StateCustomer>();
  const [btnSubmitDisabled, setBtnSubmitDisabled] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [removeCustomerConfirmModalOpen, setRemovCustomerConfirmModalOpen] =
    useState(false);
  const [phoneNumber, setPhoneNumber] = useState(
    objCustomer?.data.user.phoneNumber,
  );

  const { mutate: globalMutate } = useSWRConfig();
  const [searchParams] = useSearchParams();
  const query = searchParams.get("query") || "";
  const currentPage = Number(searchParams.get("page")) || 1;
  const offset = currentPage - 1;
  const params = `?${"name"}=${query}&${"page.limit"}=${ITEMS_PER_PAGE}&${"page.offset"}=${offset}`;

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (
      phoneNumber !== "" &&
      phoneNumber !== "+" &&
      !validatePhoneNumber(phoneNumber)
    ) {
      setResponseData({ errors: { phone: ["Invalid phone number"] } });
      return;
    }
    setResponseData(null);
    const formData = new FormData(event.currentTarget as HTMLFormElement);
    formData.forEach(
      (value, property: string) => (responseBody[property] = value),
    );
    formData.set("phone", phoneNumber);
    try {
      setBtnSubmitDisabled(true);
      const response = await updateCustomer(
        objCustomer.data.user.organization.id,
        formData,
      );
      setBtnSubmitDisabled(false);
      setResponseData(response);
      if (response.strReturn) {
        // const idCreated = response.strReturn;
        globalMutate([`/user/customers${params}`, user.token]);
        globalMutate([
          `/user/customers/${objCustomer.data.user.organization.id}`,
          user.token,
        ]);
        navigate(
          `/dashboard/customers/${objCustomer.data.user.organization.id}/sites`,
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function handleRemoveCustomer(orgId: string) {
    try {
      console.log("handle Remove Customer with orgId = ", orgId);
      const response = await deleteCustomer(orgId);
      if (response) {
        window.location.replace(`/dashboard/customers`);
        showToast(0, "The customers has been removed successfully!");
      }
    } catch (error) {
      console.error(error);
      navigate(`?modal=true&content=${error}`);
    }
  }

  return (
    <>
      <div className="max-w-lg mx-auto">
        <div className="flex gap-4 justify-center1 items-center mb-5">
          <button
            // onClick={() => navigate(-1)}
            onClick={() => {
              setModalOpen(true);
            }}
          >
            <ArrowLeftIcon width="20" />
          </button>
          <h2 className="text-lg font-medium">Customer Account Settings</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="rounded-md p-4 md:p-6">
            {/* Customer Name */}
            <div className="mb-4">
              <label htmlFor="name" className="mb-2 block text-sm">
                Account Name (The name displayed on your customer list)
              </label>
              <div className="relative mt-2 rounded-md">
                <div className="relative">
                  <input
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Account Name"
                    className="block w-full rounded-md border border-gray-200 px-3 py-2 text-sm outline-2 placeholder:text-gray-500"
                    aria-describedby="name-error"
                    defaultValue={objCustomer && objCustomer.data.accountName}
                  />
                </div>
                <div id="name-error" aria-live="polite" aria-atomic="true">
                  {responseData?.errors?.name &&
                    responseData.errors.name.map((error: string) => (
                      <p className="mt-2 text-sm text-red-500" key={error}>
                        {error}
                      </p>
                    ))}
                </div>
              </div>
            </div>

            {/* Customer Email */}
            <div className="mb-4">
              <label htmlFor="email" className="mb-2 block text-sm">
                Customer Email
              </label>
              <div className="relative mt-2 rounded-md">
                <div className="relative">
                  <input
                    id="email"
                    name="email"
                    type="text"
                    placeholder="Customer Email"
                    className="block w-full rounded-md border border-gray-200 px-3 py-2 text-sm outline-2 placeholder:text-gray-500"
                    aria-describedby="email-error"
                    defaultValue={objCustomer && objCustomer.data.user.email}
                    readOnly
                  />
                </div>
                <div id="email-error" aria-live="polite" aria-atomic="true">
                  {responseData?.errors?.email &&
                    responseData.errors.email.map((error: string) => (
                      <p className="mt-2 text-sm text-red-500" key={error}>
                        {error}
                      </p>
                    ))}
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 md:gap-6">
              {/* First Name */}
              <div className="mb-4">
                <label htmlFor="first_name" className="mb-2 block text-sm">
                  First Name
                </label>
                <div className="relative mt-2 rounded-md">
                  <div className="relative">
                    <input
                      id="first_name"
                      name="first_name"
                      type="text"
                      placeholder="First Name"
                      className="block w-full rounded-md border border-gray-200 px-3 py-2 text-sm outline-2 placeholder:text-gray-500"
                      aria-describedby="first-name-error"
                      defaultValue={
                        objCustomer && objCustomer.data.user.firstName
                      }
                    />
                  </div>
                  <div
                    id="first-name-error"
                    aria-live="polite"
                    aria-atomic="true"
                  >
                    {responseData?.errors?.first_name &&
                      responseData.errors.first_name.map((error: string) => (
                        <p className="mt-2 text-sm text-red-500" key={error}>
                          {error}
                        </p>
                      ))}
                  </div>
                </div>
              </div>

              {/* Last Name */}
              <div className="mb-4">
                <label htmlFor="last_name" className="mb-2 block text-sm">
                  Last Name
                </label>
                <div className="relative mt-2 rounded-md">
                  <div className="relative">
                    <input
                      id="last_name"
                      name="last_name"
                      type="text"
                      placeholder="Last Name"
                      className="block w-full rounded-md border border-gray-200 px-3 py-2 text-sm outline-2 placeholder:text-gray-500"
                      aria-describedby="last-name-error"
                      defaultValue={
                        objCustomer && objCustomer.data.user.lastName
                      }
                    />
                  </div>
                  <div
                    id="last-name-error"
                    aria-live="polite"
                    aria-atomic="true"
                  >
                    {responseData?.errors?.last_name &&
                      responseData.errors.last_name.map((error: string) => (
                        <p className="mt-2 text-sm text-red-500" key={error}>
                          {error}
                        </p>
                      ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Phone */}
            <div className="mb-4">
              <label htmlFor="phone" className="mb-2 block text-sm">
                Phone Number
              </label>
              <div className="relative mt-2 rounded-md">
                <div className="relative h-[37px]">
                  <PhoneInput
                    value={objCustomer.data.user.phoneNumber}
                    onChange={(phone) => {
                      setPhoneNumber(phone);
                    }}
                  />
                </div>
                <div id="phone-error" aria-live="polite" aria-atomic="true">
                  {responseData?.errors?.phone &&
                    responseData.errors.phone.map((error: string) => (
                      <p className="mt-2 text-sm text-red-500" key={error}>
                        {error}
                      </p>
                    ))}
                </div>
              </div>
            </div>
          </div>
          <div className="mt-6 flex justify-end gap-4">
            <button
              className="bg-white hover:text-red-400 text-red-500 font-semibold"
              onClick={(e) => {
                setRemovCustomerConfirmModalOpen(true);
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              Delete
            </button>
            <Button type="submit" aria-disabled={btnSubmitDisabled}>
              Save
            </Button>
          </div>
          {responseData?.message && (
            <div
              className="p-4 mb-4 mt-12 text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400 flex items-center space-x-1"
              role="alert"
              aria-live="polite"
              aria-atomic="true"
            >
              <ExclamationCircleIcon className="h-5 w-5 text-red-500" />
              <p className="text-sm text-red-500">{responseData.message}</p>
            </div>
          )}
        </form>
      </div>
      <Modal
        isOpen={modalOpen}
        style={ConfirmModalStyles}
        contentLabel="Example Modal"
      >
        <h1 className="text-xl font-bold">You have unsaved changes</h1>
        <div className="text-base mt-4">
          Are you sure you want to discard your unsaved changes?
        </div>

        <div className="float-right mt-6">
          <button
            className="rounded-2xl bg-white px-6 py-4 border border-blue-500 hover:border-blue-400 text-sm  transition-colors text-blue-500 hover:text-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
            onClick={() => {
              setModalOpen(false);
            }}
          >
            Cancel
          </button>
          <button
            className="ml-4 rounded-2xl px-6 py-4 bg-blue-500 text-sm font-medium text-white transition-colors hover:bg-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
            onClick={() => {
              setModalOpen(false);
              // reset();
              navigate(-1);
            }}
          >
            Discard
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={removeCustomerConfirmModalOpen}
        style={ConfirmModalStyles}
        contentLabel="Example Modal"
      >
        <h1 className="text-xl font-bold">
          Do you want to delete the customer?
        </h1>
        <div className="text-base mt-4">
          This customer and its associated site(s) will be permanently deleted
        </div>

        <div className="float-right mt-6">
          <button
            className="rounded-2xl bg-white px-6 py-4 border border-blue-500 hover:border-blue-400 text-sm  transition-colors text-blue-500 hover:text-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
            onClick={() => {
              setRemovCustomerConfirmModalOpen(false);
            }}
          >
            Cancel
          </button>
          <button
            className="ml-4 rounded-2xl px-6 py-4 bg-red-500 text-sm font-medium text-white transition-colors hover:bg-red-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500 active:bg-red-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
            onClick={() => {
              setRemovCustomerConfirmModalOpen(false);
              handleRemoveCustomer(objCustomer.data.user.organization.id);
            }}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
}
